import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
/* eslint-disable max-len */
export function NovaIcon(t0) {
  const $ = _c(3);
  const {
    width: t1
  } = t0;
  const width = t1 === undefined ? 18 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M9.375 0C10.4105 0 11.25 0.839466 11.25 1.875C11.25 2.64356 10.7868 3.30228 10.125 3.5918V5.84863H12.1875C14.6376 5.84863 16.6803 7.52647 17.1484 9.75488C17.182 9.75263 17.2158 9.75 17.25 9.75C18.0784 9.75 18.75 10.4216 18.75 11.25V12C18.7499 12.8283 18.0784 13.5 17.25 13.5C17.1908 13.5 17.1326 13.4949 17.0752 13.4883C16.4955 15.5676 14.5278 17.0986 12.1875 17.0986H6.5625C4.22207 17.0986 2.25345 15.5677 1.67383 13.4883C1.61674 13.4949 1.55886 13.5 1.5 13.5C0.671634 13.5 9.8446e-05 12.8283 0 12V11.25C0 10.4216 0.671573 9.75 1.5 9.75C1.53384 9.75 1.5673 9.75268 1.60059 9.75488C2.06863 7.52637 4.11237 5.84863 6.5625 5.84863H8.625V3.5918C7.96321 3.30228 7.5 2.64356 7.5 1.875C7.5 0.839466 8.33947 0 9.375 0ZM6.5625 8.04883C4.60991 8.04883 3.78223 9.60565 3.78223 10.7285V12.2188C3.78223 13.3416 4.60991 14.8984 6.5625 14.8984H12.1875C14.3347 14.8984 14.9678 13.3416 14.9678 12.2188V10.7285C14.9678 9.60565 13.9994 8.04883 12.1875 8.04883H6.5625ZM6.62305 10.1367C7.40469 10.1367 8.03809 10.7711 8.03809 11.5527C8.0379 12.3342 7.40457 12.9678 6.62305 12.9678C5.8415 12.9678 5.20819 12.3342 5.20801 11.5527C5.20801 10.7711 5.84139 10.1367 6.62305 10.1367ZM12.2842 10.1367C13.0658 10.1367 13.6992 10.7711 13.6992 11.5527C13.699 12.3342 13.0657 12.9678 12.2842 12.9678C11.5027 12.9677 10.8693 12.3342 10.8691 11.5527C10.8691 10.7711 11.5026 10.1368 12.2842 10.1367Z" fill="#3C461E" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== width) {
    t3 = <svg width={width} height={width} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}</svg>;
    $[1] = width;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}